export function readOptionalModuleExport<T>(module: unknown, key: string): T | undefined {
  try {
    return (module as Record<string, unknown>)?.[key] as T | undefined
  } catch {
    return undefined
  }
}

